import {
  FORMAT_MM_DD_YYYY,
  ISO_DATE_FORMAT,
  formatDate,
  getDateFromFormat,
} from 'utils/dates'

import { translateText } from '../sdks/localize'

export const EMPTY_DELIVERY_WINDOW = '—'

export const getDeliveryWindowText = (
  startShipDate,
  endShipDate,
  fallback = translateText('Immediate'),
  parseDateFormat = ISO_DATE_FORMAT,
  outputDateFormat = FORMAT_MM_DD_YYYY,
) => {
  if (startShipDate) {
    return `${formatDate(
      getDateFromFormat(startShipDate, parseDateFormat, { utc: true }),
      outputDateFormat,
      true,
    )}${
      endShipDate
        ? ` - ${formatDate(
            getDateFromFormat(endShipDate, parseDateFormat, { utc: true }),
            outputDateFormat,
            true,
          )}`
        : ''
    }`
  }
  return fallback
}

export const getDefaultDeliveryWindow = (creationDate = new Date()) => {
  const startDate = new Date(creationDate)
  const endDate = new Date(
    new Date(creationDate).setDate(new Date(creationDate).getDate() + 14),
  )
  return {
    startDate: formatDate(startDate, 'YYYY-MM-DD'),
    endDate: formatDate(endDate, 'YYYY-MM-DD'),
  }
}

export const getAggregatedSkuDeliveryRange = (
  skuDeliveries = [],
  userDateFormat = FORMAT_MM_DD_YYYY,
) => {
  const startShipDates = skuDeliveries
    .map((skuDelivery) => skuDelivery.startShipDate)
    .filter((startShipDate) => startShipDate !== null)
    .sort()
  const completeShipDates = skuDeliveries
    .map((skuDelivery) => skuDelivery.completeShipDate)
    .filter((completeShipDates) => completeShipDates !== null)
    .sort()
  return getDeliveryWindowText(
    startShipDates[0],
    completeShipDates[completeShipDates.length - 1],
    EMPTY_DELIVERY_WINDOW,
    undefined,
    userDateFormat,
  )
}
